import { render } from "./SelectInput.vue?vue&type=template&id=13d9e6b1"
import script from "./SelectInput.vue?vue&type=script&lang=js"
export * from "./SelectInput.vue?vue&type=script&lang=js"

import "./SelectInput.vue?vue&type=style&index=0&id=13d9e6b1&lang=scss"
script.render = render

export default script